"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.client = void 0;
const axios_class_1 = require("./axios.class");
class Client {
    getSettings() {
        return axios_class_1.axios.get('/v1/clients/settings');
    }
    async getSavStores(clientId) {
        const { data } = await axios_class_1.axios.get(`/v1/clients/${clientId}/savStores`);
        return data;
    }
    async getSpaces() {
        const { data } = await axios_class_1.axios.get(`/v1/clients/spaces`);
        return data;
    }
    async getClients() {
        const { data } = await axios_class_1.axios.get(`/v1/clients/getClients`);
        return data;
    }
    async getClientLogo(clientId) {
        const { data } = await axios_class_1.axios.get(`/v1/clients/${clientId}/logo`);
        return data;
    }
    /**
     * Fetch collection by client.
     */
    async getCollectionByClient() {
        const { data } = await axios_class_1.axios.get(`/v1/clients/collections`);
        return data;
    }
}
exports.client = new Client();
